<template lang="pug">
	header.header(:class="{'header_active': isPanelActive}" :style="{top: headerTop}")
		.wrapper
			router-link.logo(to="/" @click.native="isSearchActive = false")
				img.logo__img(src="@/assets/img/logo.svg")
			nav.nav
				router-link.nav__item(to="/about/" :class="{'nav__item_active': $route.name.toLowerCase() === 'about'}" @click.native="isPanelActive = false") Про компанію
				router-link.nav__item(to="/products/" :class="{'nav__item_active': $route.name.toLowerCase() === 'products' || $route.name.toLowerCase() === 'product'}" @click.native="isPanelActive = false") Продукти
				router-link.nav__item(to="/cultures/" :class="{'nav__item_active': $route.name.toLowerCase() === 'cultures' || $route.name.toLowerCase() === 'culture'}" @click.native="isPanelActive = false") Культури
				router-link.nav__item(to="/contacts/" :class="{'nav__item_active': $route.name.toLowerCase() === 'contacts'}" @click.native="isPanelActive = false") Контакти
				router-link.nav__item(to="/distributors/" :class="{'nav__item_active': $route.name.toLowerCase() === 'distributors'}") Дистриб'ютори
				router-link.nav__item(to="/news/" :class="{'nav__item_active': $route.name.toLowerCase() === 'news' || $route.name.toLowerCase() === 'new' || $route.name.toLowerCase() === 'promos' || $route.name.toLowerCase() === 'promo'}" @click.native="isPanelActive = false") Новини та Акції
				router-link.nav__item(to="/articles/" :class="{'nav__item_active': $route.name.toLowerCase() === 'articles' || $route.name.toLowerCase() === 'article' || $route.name.toLowerCase() === 'fieldnews'}" @click.native="isPanelActive = false") Публікації
				router-link.nav__item(to="/video/" :class="{'nav__item_active': $route.name.toLowerCase() === 'videos' || $route.name.toLowerCase() === 'video'}" @click.native="isPanelActive = false") Відео
			.right
				button.btn-search(@click="isSearchActive = true, isPanelActive = false")
				button.menu(@click="isPanelActive = isPanelActive ? false : true, isSearchActive = false" :class="{'menu_active': isPanelActive}")
					.menu__el
					.menu__el
					.menu__el
		.panel(:class="{'panel_active': isPanelActive}")
			router-link.panel__item(to="/about/" :class="{'panel__item_active': $route.name.toLowerCase() === 'about'}" @click.native="isPanelActive = false") Про компанію
			router-link.panel__item(to="/products/" :class="{'panel__item_active': $route.name.toLowerCase() === 'products' || $route.name.toLowerCase() === 'product'}" @click.native="isPanelActive = false") Продукти
			router-link.panel__item(to="/cultures/" :class="{'panel__item_active': $route.name.toLowerCase() === 'cultures' || $route.name.toLowerCase() === 'culture'}" @click.native="isPanelActive = false") Культури
			router-link.panel__item(to="/contacts/" :class="{'panel__item_active': $route.name.toLowerCase() === 'contacts'}" @click.native="isPanelActive = false") Контакти
			router-link.panel__item(to="/distributors/" :class="{'panel__item_active': $route.name.toLowerCase() === 'distributors'}" @click.native="isPanelActive = false") Дистриб'ютори
			router-link.panel__item(to="/news/" :class="{'panel__item_active': $route.name.toLowerCase() === 'news' || $route.name.toLowerCase() === 'new' || $route.name.toLowerCase() === 'promos' || $route.name.toLowerCase() === 'promo' || $route.name.toLowerCase() === 'fieldnews'}" @click.native="isPanelActive = false") Новини та Акції
			router-link.panel__item(to="/articles/" :class="{'panel__item_active': $route.name.toLowerCase() === 'articles'}" @click.native="isPanelActive = false") Публікації
			router-link.panel__item(to="/video/" :class="{'panel__item_active': $route.name.toLowerCase() === 'videos' || $route.name.toLowerCase() === 'video'}" @click.native="isPanelActive = false") Відео
		.search(:class="{'search_active': isSearchActive}" v-if="catalogs.length && isSearchActive")
			.search__row
				.search__input
					button.search__close(@click="isSearchActive = false, search = ''")
					input(v-model="search")
					.search__label Введіть назву продукту
			.search__row
				.wrapper
					.search__title(v-text="searchProducts.length ? ((searchProducts.length > 9 ? searchProducts.length : ('0' + searchProducts.length)) + ' результати за запитом ' + search) : ''")
					.list
						router-link.card(v-for="(card, index) in searchProducts" :key="index"  :to="'/products/' + (getCatalogById(card.catalogs[0]) ? getCatalogById(card.catalogs[0]).slug : '') + '/' + card.slug + '/'")
							.card__image(:style="{backgroundImage: 'url('+(card.background_link ? card.background_link[400] : '')+')'}")
							.card__content
								.card__title(v-html="card.name")
								.card__text(v-text="card.purpose")
								.card__btn Більше
									span
					.list.list_mobile
						router-link.card.card_mobile(v-for="(card, index) in searchProducts" :key="index" :to="'/products/' + (getCatalogById(card.catalogs[0]) ? getCatalogById(card.catalogs[0]).slug : '') + '/' + card.slug + '/'")
							.card__image(:style="{backgroundImage: 'url('+(card.background_link ? card.background_link[400] : '')+')'}")
							.card__content
								.card__title(v-html="card.name")
								.card__text(v-text="card.purpose")
						//- .card
						//- 	.card__image
						//- 	.card__content
						//- 		.card__title <span>Карібу</span>® Дуо Актив
						//- 		.card__text Репутація, визнана професіоналами
						//- 		router-link.card__btn(to="/") Більше
						//- 			span

</template>

<script>

	import {mapState, mapGetters} from 'vuex';

	export default {
		name: 'block-header',
		data: function(){
			return {
				isPanelActive: false,
				isSearchActive: false,
				search: '',
			}
		},
		created() {
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
			this.isPanelActive = false;
			this.offScroll();
      this.getWidth();
      window.addEventListener('resize', this.getWidth, false);
		},
		computed: {
			...mapState([
				'searchProducts',
				'catalogs',
        'withBanner',
        'desk',
			]),
			...mapGetters([
				'getCatalogById'
			]),
			headerTop: function() {
        return !this.desk && this.withBanner ? '61px' : '0px'
			},
		},
		methods: {
			getTitle(title) {
				let tit = title;
				let h = title.toLowerCase();
				let i = h.indexOf(this.search.toLowerCase());
				tit = tit.slice(i, this.search.length);
				return tit;
			},
			offScroll() {
				let page = document.querySelector('body');
				page.style = this.isPanelActive ? 'overflow: hidden; height: 100vh; position: fixed' : 'overflow: auto; height: auto; position: static';
			},
			focusSearch() {
				let input = document.querySelector('.search__input input');
				setTimeout(() => {
					input.focus();
				}, 200);
			},
      getWidth() {
        this.$store.dispatch('CHANGE_DESK', window.innerWidth > 1200);
        if(this.desk) {
          document.querySelector('body').style.paddingTop = '0px';
        }
      },
		},
		beforeDestroy() {

		},
		watch: {
			search() {
				if (this.search.length) this.$store.dispatch('SEARCH_PRODUCTS', this.search);
				else this.$store.commit('clearSearch');
			},
			isPanelActive() {
				this.offScroll();
			},
			isSearchActive() {
				if(this.isSearchActive) this.focusSearch();
			},
			$route() {
				this.isSearchActive = this.isSearchActive ? !this.isSearchActive : this.isSearchActive;
			}
		}
	}

</script>

<style lang="scss" scoped>

	.card {
		height: 152px;
		margin-bottom: 30px;
		display: block;

		// &_mobile {
		// 	display: none;
		// }

		&__image {
			display: inline-block;
			vertical-align: top;
			width: 305px;
			height: 100%;
			background-size: cover;
			background-position: center;
			margin-right: 15px;
			background-color: #555;
		}

		&__content {
			display: inline-block;
			vertical-align: top;
			height: 100%;
			position: relative;
			width: calc(100% - 320px);
		}

		&__title {
			font: 700 28px/33px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;

      >>> span {
				color: #EF3E33;
			}
		}

		&__text {
			margin-top: 22px;
			font: 14px/16px 'Helvetica', Arial, sans-serif;
			letter-spacing: .5px;
		}

		&__btn {
			display: block;
			position: absolute;
			bottom: 0;
			left: 0;
			background-color: #EF3E33;
			height: 30px;
			padding: 0 50px 0 20px;
			font: 500 11px/32px 'Helvetica', Arial, sans-serif;
			text-transform: uppercase;
			letter-spacing: 1px;
			color: #fff;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.1);

			span {
				width: 30px;
				height: 30px;
				position: absolute;
				top: 0;
				right: 0;
				background: url('../../assets/img/btn.svg') no-repeat center center;
			}

			&:after {
				content: "";
				display: block;
				position: absolute;
				width: calc(100% - 30px);
				height: 100%;
				top: 0;
				left: 0;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			}
		}
	}

	.search {
		position: absolute;
		min-height: calc(100vh - 90px);
		background-color: #F2F2F2;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.05);
		top: 90px;
		left: 0;
		width: 100%;
		z-index: 10;
		opacity: 0;
		visibility: hidden;
		pointer-events: none;
		transition: opacity .5s ease, visibility .5s ease;

		&_active {
			opacity: 1;
			visibility: visible;
			pointer-events: all;
		}

		&__close {
			position: absolute;
			width: 50px;
			height: 50px;
			top: 0;
			right: 0;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.05);
			background: url('../../assets/img/close.svg') no-repeat center center;
		}

		&__input {
			display: block;
			max-width: 640px;
			width: 100%;
			margin: 30px auto;
			position: relative;

			input {
				height: 100%;
				width: 100%;
				background-color: #fff;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.05);
				height: 50px;
				padding: 0 20px;
				font: 300 21px 'Helvetica', Arial, sans-serif;
				letter-spacing: 1px;
			}
		}

		&__label {
			margin-top: 9px;
			font: 300 10px/1.3 'Helvetica', Arial, sans-serif;
			letter-spacing: .5px;
			padding-left: 20px;
		}

		&__title {
			font: 700 21px/1 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}
	}

	.list {
		margin-top: 45px;
		margin-bottom: 50px;

		&_mobile {
			display: none;
		}
	}

	.header {
		height: 90px;
	}

	.panel {
		display: none;
	}

	.logo {
		display: inline-block;
		vertical-align: top;
		margin-top: 30px;
	}

	.nav {
		margin-top: 35px;
		display: inline-block;
		vertical-align: top;
		margin-left: 12.1%;

		&__item {
			display: inline-block;
			vertical-align: middle;
			margin-right: 20px;
			font: 14px/21px Arial, sans-serif;
			letter-spacing: .58px;
			transition: opacity .5s ease, color .5s ease;

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;

					&.nav__item_active {
						opacity: 1;
					}
				}
			}

			&:last-child {
				margin-right: 0;
			}

			&_active {
				color: #ed3e33;
			}
		}
	}

	.right {
		float: right;
	}

	.btn-search {
		display: inline-block;
		width: 50px;
		height: 50px;
		background: url('../../assets/img/search.svg') #EF3E33 no-repeat center center;
		margin-top: 20px;
	}

	.menu {
		display: none;
	}

	@media screen and (max-width: 1200px) {

		.header {
			&:before {
				content: "";
				display: block;
				position: absolute;
				width: 100%;
				height: 50px;
				background-color: #fff;
				z-index: 1;
				transition: opacity .5s ease;
				opacity: 0;
				pointer-events: none;
			}

			&_active {
				&:before {
					opacity: 1;
				}
			}
		}

		.card {
			margin-bottom: 20px;
			width: 100%;
			height: auto;
			// display: none;

			// &_mobile {
			// 	display: block;
			// }

			&__image {
				width: 100%;
				margin-right: 0;
				display: block;
				height: 152px;
			}

			&__content {
				display: block;
				width: 100%;
				background-color: #fff;
				height: auto;
				padding: 20px;
			}

			&__title {
				font-size: 21px;
				line-height: 1;
			}

			&__text {
				margin-top: 4px;
				font-size: 14px;
				line-height: 16px;
			}

			&__btn {
				display: none;
			}
		}

		.search {
			top: 50px;
			min-height: calc(100vh - 50px);

			&__input {
				margin-top: 0;
				margin-bottom: 20px;
			}

			&__title {
				font-size: 14px;
			}
		}

		.list {
			margin-top: 20px;
			display: none;
			overflow: auto;
			max-height: calc(100vh - 90px - 150px);

			&_mobile {
				display: block;
			}
		}

		.header {
			height: 50px;
			position: fixed;
			z-index: 10;
			width: 100%;
			left: 0;
			background: #F2F2F2;
		}

		.logo {
			margin-top: 15px;
			position: relative;
			z-index: 1;

			&__img {
				width: 69px;
			}
		}

		.btn-search {
			display: inline-block;
			vertical-align: top;
			width: 50px;
			height: 50px;
			margin-top: 0;
			background: url('../../assets/img/search_mob.svg') no-repeat center center;
			position: relative;
			z-index: 1;


		}

		.nav {
			display: none;
		}

		.menu {
			display: inline-block;
			vertical-align: top;
			width: 50px;
			height: 50px;
			background-color: #EF3E33;
			margin-right: -20px;
			margin-left: 24px;
			position: relative;
			position: relative;
			z-index: 1;
			transition: background-color .5s ease;

			&__el {
				position: absolute;
				top: calc(50% - 1px);
				left: 50%;
				width: 18px;
				height: 2px;
				background-color: #fff;
				transition: transform .5s ease, opacity .5s ease;

				&:nth-child(1) {
					transform: translate3d(-50%, -5px, 1px);
				}

				&:nth-child(2) {
					transform: translate3d(-50%, 0, 1px);
				}

				&:nth-child(3) {
					transform: translate3d(-50%, 5px, 1px);
				}
			}

			&:after {
				content: "";
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				opacity: 0;
				transition: opacity .5s ease;
				background: url('../../assets/img/close.svg') no-repeat center center;
			}

			&_active {
				background-color: #fff;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.05);

				.menu__el {
					opacity: 0;
				}

				&:after {
					opacity: 1;
				}
			}
		}

		.panel {
			display: block;
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			overflow: auto;
			padding: 114px 20px 50px;
			background: #FFFFFF;
			opacity: 0;
			pointer-events: none;
			visibility: hidden;
			transition: opacity .5s ease, visibility .5s ease;

			&_active {
				opacity: 1;
				pointer-events: all;
				visibility: visible;
			}

			&__item {
				display: block;
				font: 700 21px/1 'Helvetica', Arial, sans-serif;
				padding: 19px 20px;
				border-top: 1px solid rgba(#4F4F4F, .1);
				letter-spacing: 1px;

				&:last-child {
					border-bottom: 1px solid rgba(#4F4F4F, .1);
				}

				&_active {
					color: #EF3E33;
				}
			}
		}
	}


</style>
